import * as d3 from "d3";
import i18n from "../lang/lang";
import tooltip from "bootstrap/js/src/tooltip";

// Se usa como clase principal. Las otras gráficas heredan de acá los métodos básicos
// Revisar documentación de d3 versión 4.
// Revisar como en las otras cosas como se usa esta.
// Revisar el funcionamiento de ChartBarSimpleHorizontal, esa clase esta comentada y así funcionan el resto

export function Chart(alias, legend, margin, squaredChart = false) {
  this.alias = alias;
  this.legend = legend || false;
  this.svg = {};
  var element = d3.select("#" + this.alias).node();
  this.svgWidth = element.getBoundingClientRect().width;
  this.svgHeight = squaredChart
    ? element.getBoundingClientRect().width
    : element.getBoundingClientRect().height;

  // set the dimensions and margins of the graph
  this.margin = margin || { top: 30, right: 80, bottom: 50, left: 120 };
  if (this.legend) {
    this.margin.bottom = 100;
  }
  this.chartWidth = this.svgWidth - this.margin.left - this.margin.right;
  this.chartHeight = this.svgHeight - this.margin.top - this.margin.bottom;

  this.fontSize = "1rem";
  this.transition = d3
    .transition()
    .duration(1000)
    .ease(d3.easeLinear)
    .delay(500);

  this.getColor = function (label) {
    return i18n.tc(label + "_color");
  };

  this.prepareSvg = function () {
    var element = d3.select("#" + this.alias).node();
    this.svgWidth = element.getBoundingClientRect().width;
    this.svgHeight = squaredChart
      ? element.getBoundingClientRect().width
      : element.getBoundingClientRect().height;

    this.svg = d3
      .select("#" + this.alias)
      .append("svg")
      .attr("class", "chart")
      .attr("width", this.svgWidth)
      .attr("height", this.svgHeight)
      .append("g")
      .attr(
        "transform",
        "translate(" + this.margin.left + "," + this.margin.top + ")"
      );
  };

  this.drawAxis = function (x, y, xLabel, yLabel, percentage, hideY = false) {
    xLabel = xLabel || "";
    yLabel = yLabel || "";
    percentage = percentage || false;

    var yAxis = d3.axisLeft(y).ticks(5);
    var xAxis = d3.axisBottom(x).ticks(5).tickSizeOuter([0]).tickSizeInner([0]);

    if (percentage) {
      xAxis.tickFormat(d3.format(".0%"));
    }

    this.svg
      .append("g")
      .attr("transform", "translate(0," + this.chartHeight + ")")
      .call(xAxis)

    if (!hideY) {
      this.svg
        .append("g")
        .call(yAxis)
        .selectAll(".tick text")
        .call(this.wrap, 115);
    }

    this.svg
      .append("g")
      .append("text")
      .attr(
        "transform",
        "translate(" + this.chartWidth / 2 + "," + (this.chartHeight + 30) + ")"
      )
      .attr("dy", "0.32em")
      .attr("text-anchor", "middle")
      .style("font-family", "Montserrat-Regular")
      .style("font-weight", "bold")
      .text(i18n.tc(xLabel));

    this.svg
      .append("g")
      .append("text")
      .attr("transform", "translate(-100, -10)")
      .style("font-family", "Montserrat-Regular")
      .style("font-weight", "bold")
      .text(i18n.tc(yLabel));
  };

  // Formatea el texto para mostrarlo de forma adecuada
  // Con la puntuación, los 2 ceros decimales, si es porcentaje
  this.format = function (d, withPercentage) {
    var text = "";
    var percentage =
      withPercentage && d.percentage
        ? " (" + d3.format(".2%")(d.percentage) + ")"
        : "";
    switch (d.type) {
      case "integer":
        if(isNaN(d.value)) {
          text = '';
        } else if (Number.isInteger(d.value)) {
          text = d3.format("(,.0f")(d.value) + percentage;
        } else {
          text = d3.format("(,.2f")(d.value) + percentage;
        }
        break;
      case "currency":
        text = d3.format("($,.2f")(d.value) + percentage;
        break;
      default:
        if(isNaN(d.percentage)) {
          text = '';
        }
        else if (d.percentage || d.percentage === 0) {
          text = d3.format(".2%")(d.percentage);
        } else {
          if (Number.isInteger(d.value)) {
            text = d3.format("(,.0f")(d.value);
          } else {
            text = d3.format("(,.2f")(d.value);
          }
        }
        break;
    }
    return text;
  };

  this.openTooltip = function (text, fontSize = 1) {
    this.tooltipBox = document.createElement('div');
    document.body.append( this.tooltipBox);
    this.tooltipBox.style.position ='absolute'
    this.tooltipBox.innerText = text
    this.tooltipBox.style.width =`200px`
    this.tooltipBox.style.color =`#000`
    this.tooltipBox.style.textAnchor =`middle`
    this.tooltipBox.style.backgroundColor =`#FFF`
    this.tooltipBox.style.fontSize =`${fontSize}rem`
    this.tooltipBox.style.border =`1px solid gray`
    this.tooltipBox.style.borderRadius =`5px`
    this.tooltipBox.style.padding =`5px 10px`
    this.tooltipBox.style.textAlign =`center`

    //
    // this.tooltipBox = this.svg
    //   .append("g")
    //   .attr("class", "tooltip-box")
    //   .style("opacity", 0);
    // this.tooltipBox.transition().duration(200).style("opacity", 1);
    //
    // this.tooltipBox
    //   .append("text")
    //   .attr("class", "tooltip-text")
    //   .attr("stroke", "none")
    //   .style("text-anchor", "middle")
    //   .style("font-family", "Montserrat-Regular")
    //   .style("font-size", fontSize + "rem")
    //   .attr("fill", "#000")
    //   .style("pointer-events", "none")
    //   .attr("x", 0)
    //   .attr("y", () => {
    //     var lines = parseInt(text.length / 25) + 1;
    //     return -(24 * lines + 4) / 2 + 20;
    //   })
    //   .attr("dy", 0)
    //   .text(text)
    //   .call(this.wrap, 150, true);
  };

  this.closeTooltip = function () {
    // this.tooltipBox.transition().duration(200).style("opacity", 0);
     this.tooltipBox.remove();
  };

  this.moveTooltip = function (x, y) {
   // this.tooltipBox.attr("transform", "translate(" + x + "," + y + ")");
    this.tooltipBox.style.left =`${d3.event.pageX - (this.tooltipBox.offsetWidth / 2)}px`
    this.tooltipBox.style.top =`${d3.event.pageY - this.tooltipBox.offsetHeight - 5}px`
  };

  this.drawLegend = function (keys) {
    var legend = d3
      .select("#" + this.alias)
      .selectAll("svg")
      .append("g")
      .attr("font-family", "sans-serif")
      .attr("font-size", 10)
      .attr("transform", () => {
        return (
          "translate(" +
          this.margin.left +
          "," +
          (this.chartHeight + this.margin.top + 25) +
          ")"
        );
      })
      .selectAll("g")
      .data(keys.slice().reverse())
      .enter()
      .append("g")
      .attr("transform", (d, i) => {
        var col = i % 2;
        var posX = col === 0 ? 0 : this.chartWidth / 2;
        var posY = parseInt(i / 2) * 22;
        return "translate(" + posX + "," + posY + ")";
      });

    legend
      .append("rect")
      .attr("x", 0)
      .attr("width", 19)
      .attr("height", 19)
      .attr("fill", (d) => {
        return this.getColor(d);
      });

    legend
      .append("text")
      .attr("x", 22)
      .attr("y", 9.5)
      .attr("dy", "0.32em")
      .text(function (d) {
        return i18n.tc(d);
      });
  };

  this.wrap = function (text, width, background) {
    background = background || false;
    text.each(function () {
      var text = d3.select(this);
      var rect = d3.select(this.parentNode);
      d3.select(this.parentNode).select(".text-background").remove();
      var words = text.text().split(/\s+/).reverse();
      var word;
      var line = [];
      var lineNumber = 0;
      var lineHeight = 1.1; // ems
      var x = text.attr("x");
      var y = text.attr("y");
      // var ttx0 = x - (width / 2) // Toltip x position in the left
      // var ttx1 = ttx0 + width
      var dy = 0; // parseFloat(text.attr("dy")),
      var tspan = text
        .text(null)
        .append("tspan")
        .attr("x", x)
        .attr("y", y)
        .attr("dy", dy + "em")
        .attr("dx", 0 + "em");
      var tBackground = rect.append("rect");
      if (background) {
        tBackground
          .attr("class", "text-background")
          .attr("width", width + 6)
          .style("pointer-events", "none")
          .attr("rx", 5)
          .attr("ry", 5)
          .attr("x", x - width / 2)
          .attr("y", y - 18)
          .style("z-index", 0)
          .attr("width", 150)
          .attr("fill", "#fff")
          .attr("stroke", "gray")
          .attr("stroke-width", "1")
          .attr("dy", 200 + "px")
          .lower();
      }
      while (word = words.pop()) { // eslint-disable-line
        line.push(word);
        tspan.text(line.join(" "));
        if (tspan.node().getComputedTextLength() > width) {
          line.pop();
          tspan.text(line.join(" "));
          line = [word];
          tspan = text
            .append("tspan")
            .attr("x", x)
            .attr("y", y)
            .attr("dy", ++lineNumber * lineHeight + dy + "em")
            .text(word);
        }
      }

      /*      var height
      try {
        height = tspan.node().getBBox().height
      } catch (e) {
        // Firefox problem
        height = tspan.node().getBoundingClientRect().height
      }*/
      // var tty0 = y - (height / 2) // Toltip y position in the top
      // var tty1 = tty0 + height // Toltip y position in the bottom
      // tBackground.attr('height', height + 6)
      tBackground.attr(
        "height",
        (lineNumber + 1) * (lineHeight + dy) + 0.6 + "em"
      );
    });
  };

  this.prepareSvg();
}
